export const isCorrectColumnCount = (
  headerFields: string[],
  rows: {
    [key: string]: string;
  }[]
): boolean => {
  // There's a mismatch if there's more than one distinct row length
  // And there's a mismatch if the length of the header fields isn't in the array of distinct row lengths
  const isValid = rows.every(row => headerFields.length === Object.keys(row).length);
  return isValid;
};
